export default "__VITE_ASSET__ChRR4_LI__"